import React from 'react'
import Typography from "@app/components/atoms/Typography";
import moment from 'moment'; 

export  const dateTimeVisibilityHandler = (opportunity, variant, color) => {
    if (opportunity?.start_date && !opportunity?.end_date) {
      if (opportunity?.time_visibility?.start_time) {
        return (
          <Typography variant={variant} color={color} gutterBottom>
            {`${moment(opportunity?.start_date).format('D MMM YYYY HH:mm ')}`}
          </Typography>
        );
      }
      return (
        <Typography variant={variant} color={color} gutterBottom>{`${moment(
          opportunity?.start_date
        ).format('D MMM YYYY')}`}</Typography>
      );
    }
    if (moment(opportunity?.start_date).date() === moment(opportunity?.end_date).date()) {
      return (
        <Typography variant={variant} color={color} gutterBottom>{`${moment(
          opportunity?.start_date
        ).format('D MMM YYYY')} ${moment(opportunity?.start_date).format('HH:mm')}-${moment(
          opportunity?.end_date
        ).format('HH:mm')}`}</Typography>
      );
    }
    if (moment(opportunity?.start_date).month() === moment(opportunity?.end_date).month()) {
      if (!opportunity?.time_visibility?.start_time) {
        return (
          <Typography variant={variant} color={color} gutterBottom>{`${moment(
            opportunity?.start_date
          ).format('D')} - ${moment(opportunity?.end_date).format('D MMM YYYY')} `}</Typography>
        );
      }
      return (
        <Typography variant={variant} color={color} gutterBottom>{`${moment(
          opportunity?.start_date
        ).format('D MMM HH:mm')} - ${moment(opportunity?.end_date).format(
          'D MMM HH:mm YYYY'
        )} `}</Typography>
      );
    }
    if (moment(opportunity?.start_date).year() !== moment(opportunity?.end_date).year()) {
      if (opportunity?.time_visibility?.start_time) {
        return (
          <Typography variant={variant} color={color} gutterBottom>{`${moment(
            opportunity?.start_date
          ).format('D MMM YYYY HH:mm')} - ${moment(opportunity?.end_date).format(
            'D MMM YYYY HH:mm'
          )} `}</Typography>
        );
      }
      return (
        <Typography variant={variant} color={color} gutterBottom>{`${moment(
          opportunity?.start_date
        ).format('D MMM YYYY')} - ${moment(opportunity?.end_date).format(
          'D MMM YYYY'
        )} `}</Typography>
      );
    }
    if (opportunity?.time_visibility?.start_time || opportunity?.time_visibility?.end_time) {
      return (
        <Typography variant={variant} color={color} gutterBottom>
          {`${moment(opportunity?.start_date).format('D MMM YYYY HH:mm ')} - ${moment(
            opportunity?.end_date
          ).format('D MMM YYYY HH:mm')}`}
        </Typography>
      );
    }
    return (
      <Typography variant={variant} color={color} gutterBottom>
        {`${moment(opportunity?.start_date).format('D MMM YYYY')} - ${moment(
          opportunity?.end_date
        ).format('D MMM YYYY ')}`}
      </Typography>
    );
}